import { Field, Product } from '@/shared/api/rest/models';

import * as sharedUtils from '../../../shared/seedingActionUtils';
import { MAIZE_WORKFLOW_CONFIG } from '../../../shared/seedingWorkflowConfig';

export type { WorkflowVariety, Calculation, SeedingZone } from '../../../shared/seedingActionUtils';

export const {
  getMostFrequentWorkflowVarietyInFields,
  getFirstSelectedField,
  calcHeatmapColors,
  calcBasicSeedStrengthFromManualSeedrate,
  calcKDiffFromManualSeedrate,
  getCropName,
} = sharedUtils;

export async function findMaterialBasedOnVariety(variety: sharedUtils.WorkflowVariety, selectedField: Field) {
  return sharedUtils.findMaterialBasedOnVariety(variety, selectedField, MAIZE_WORKFLOW_CONFIG);
}

export async function findMaterialBasedOnSelectedFields(
  selectedField: Field,
  variety: sharedUtils.WorkflowVariety,
  crops: Record<string, Product>,
) {
  return sharedUtils.findMaterialBasedOnSelectedFields(selectedField, variety, crops, MAIZE_WORKFLOW_CONFIG);
}
